'use client';

import { useEffect } from 'react';
import { Button } from '@/components/ui/button';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Unhandled Error:', error);
  }, [error]);

  const isTimeout =
    error.message?.includes('ETIMEDOUT') ||
    error.message?.includes('TimeoutError') ||
    error.message?.includes('aborted');

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-y-3 p-6 xl:px-0">
      <h2 className="text-lg font-semibold">
        {isTimeout ? '请求超时，请稍后重试' : '请求发生错误，请重试!'}
      </h2>
      <p className="text-sm text-muted-foreground mb-6">
        {error.message && error.message !== 'An error occurred in the Server Components render.'
          ? error.message
          : error.digest
            ? `错误代码：${error.digest}`
            : '请刷新页面或稍后重试'}
      </p>
      <Button onClick={() => reset()}>重试</Button>
    </div>
  );
}
